import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { FilterIcon } from '../../helper/imagepath'
import { convertTimestampToCalenderDate, convertTimestampToDate, convertTimestampToTime, getTimeStamp } from '../../helper/function'
import { getAllOverview } from '../../redux/slices/overviewSlice'
import { SpinnerContext } from '../../context/spinnerContext'
import { getAllRegion } from '../../redux/slices/regionSlice'
import { syncCalendar } from '../../redux/slices/calendarSlice'
import { errorToast, successToast } from '../../util/Toast/toast'
import FullCalendarView from '../../component/fullCalendar'
import OverviewFilter from '../overview/overviewFilter'

const Calendar = () => {
  const dispatch = useDispatch()
  const calendarRef = useRef()
  const { changeLoader } = useContext(SpinnerContext)
  const { allOverview } = useSelector((state) => state.overView)
  const [filterData, setFilterData] = useState({})
  const [showFilter, setShowFilter] = useState(false)
  const [dateRange, setDateRange] = useState(null)
  const [isRefresh, setIsRefresh] = useState(false)
  const CALENDAR_EVENT = useMemo(() => {
    let item = []
    if (allOverview?.scheduledProperties) {
      allOverview?.scheduledProperties?.map((overview) => {
        const newData = {
          properties_id: overview?.property_schedule_id,
          title: overview?.properties?.property_name || '',
          status: overview?.booking_status,
          host_name: overview?.properties?.client?.first_name
            ? `${overview?.properties?.client?.first_name || ''} ${overview?.properties?.client?.last_name || ''}`
            : null,
          accepted: overview?.scheduleCleaners ? (overview?.scheduleCleaners?.is_accepted ? 'Accepted' : 'Declined') : 'Pending',
          checkout: overview?.booking_date_time
            ? `${convertTimestampToDate(overview?.booking_date_time)} ${convertTimestampToTime(overview?.booking_date_time)}`
            : null,
          next_check_in: overview?.next_checkin_time
            ? `${convertTimestampToDate(overview?.next_checkin_time)} ${convertTimestampToTime(overview?.next_checkin_time)}`
            : null,
          date: overview.booking_date_time ? convertTimestampToCalenderDate(overview.booking_date_time, true) : '',
          cleaner_name: overview?.cleaners ? `${overview?.cleaners?.first_name || ''} ${overview?.cleaners?.last_name || ''}` : null
        }
        item.push(newData)
      })
    }
    return item
  }, [allOverview])

  const getOverviewData = async () => {
    // Prepare the parameters for the API call
    const params = {
      sort_column: 'booking_date_time',
      sort_order: 'DESC',
      ...(filterData?.hostname && { host_name: filterData.hostname }),
      ...(filterData?.cleaner && { cleaner_name: filterData.cleaner }),
      ...(filterData?.region && { region_id: filterData.region }),
      ...(filterData?.city_id && { city_id: filterData.city_id }),
      ...(dateRange?.start && { startTimestamps: dateRange?.start && getTimeStamp(dateRange?.start) }),
      ...(dateRange?.end && { endTimestamps: dateRange?.end && getTimeStamp(dateRange?.end) }),
      ...(filterData?.booking_status && { booking_status: filterData.booking_status })
    }
    changeLoader(true)
    await dispatch(getAllOverview(params))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(false)
        } else {
          errorToast(payload?.data?.status_message || 'Somthing went wrong!')
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
        setIsRefresh(false)
      })
  }

  useEffect(() => {
    if (dateRange) {
      getOverviewData()
    }
  }, [isRefresh, filterData, dateRange])

  useEffect(() => {
    getStateCityData()
  }, [])

  const getStateCityData = useCallback(() => {
    dispatch(getAllRegion())
      .then(() => {})
      .catch(() => {})
  }, [])

  const onDatasetChange = useCallback((arg) => {
    setDateRange({ start: arg.view.currentStart, end: arg.view.currentEnd })
  }, [])

  const onHandleSyncCalendar = () => {
    changeLoader(true)
    dispatch(syncCalendar())
      .then(({ payload, error }) => {
        if (payload?.status === 200) {
          successToast(payload?.data?.status_message || 'Success!')
          changeLoader(false)
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
      })
  }
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="content-page-header">
            <h5>Cleaning Schedule</h5>
            <div className="list-btn">
              <ul className="filter-list">
                <li>
                  <Link className="btn btn-filters w-auto popup-toggle" onClick={() => setShowFilter(!showFilter)}>
                    <span className="me-2">
                      <img src={FilterIcon} alt="filter" />
                    </span>
                    Filter
                  </Link>
                </li>
                <li>
                  <Button className="btn btn-primary" onClick={() => onHandleSyncCalendar()}>
                    Sync Calendar
                    <i className="fa-solid fa-calendar-days" style={{ marginLeft: '5px' }}></i>
                  </Button>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="">
          <FullCalendarView calendarRef={calendarRef} onDatasetChange={onDatasetChange} CALENDAR_EVENT={CALENDAR_EVENT} setIsRefresh={setIsRefresh} />
        </div>
        <OverviewFilter showFilter={showFilter} setShowFilter={setShowFilter} setFilterData={setFilterData} />
      </div>
    </div>
  )
}

export default Calendar
